import { render, staticRenderFns } from "./DriverAssign.vue?vue&type=template&id=6f2cf05c&scoped=true&"
import script from "./DriverAssign.vue?vue&type=script&lang=js&"
export * from "./DriverAssign.vue?vue&type=script&lang=js&"
import style0 from "./DriverAssign.vue?vue&type=style&index=0&id=6f2cf05c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2cf05c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VDialog,VTooltip})
